<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <draggable
            :list="arrayModelOrder"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
        >
            <div
                class="list-group-item"
                v-for="element in arrayModelOrder"
                :key="element.id"
                v-html="element.description"
            ></div>
        </draggable>
        <div v-if="arrayModelOrder.length > 1" class="mt-3">
            <button @click="saveOrder()" type="button" class="btn btn-primary">
                Actualizar orden
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            arrayModelOrder: [],
        };
    },
    methods: {
        getListModelOrder() {
            let me = this;

            axios
                .get("/api/project-phase/order")
                .then(function (response) {
                    me.arrayModelOrder = response.data;
                })
                .catch(function (error) {});
        },
        saveOrder() {
            let me = this;
            axios
                .put("/api/project-phase/order", {
                    order: me.arrayModelOrder,
                })
                .then(function (response) {
                    me.showActionSuccess();
                })
                .catch(function (error) {});
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
    },
    mounted() {
        this.getListModelOrder();
    },
};
</script>
